export default "__VITE_PUBLIC_ASSET__6de69e8e__"